/**
 * @Author：zsj
 * @Date：2022/01/07
 */

let _instance = null

class Mock {
  constructor() {
    if (_instance) {
      throw new Error('禁止new Mock()')
    }
    this.timeout = 0
    this.mockInfo = {};
    this.regxArr = []
  }

  static getInstance() {
    _instance = _instance || new this()
    return _instance
  }

  setTimeout(timeout) {
    this.timeout = timeout;
  }

  mock(regx, method, retJson) {
    if (!this.mockInfo[regx]) {
      this.mockInfo[regx] = {
        regx, method, retJson
      }
    }

    if (!this.regxArr.includes(regx)) {
      this.regxArr.push(regx)
    }
  }

  async exec(url, method) {
    const regx = this.regxArr.find(reg => reg.test(url))
    if (!regx) {
      return null
    }
    const { retJson, method: testMethod } = this.mockInfo[regx]
    if (method !== testMethod) {
      return null
    }
    return new Promise(resolve => {
      const _id = setTimeout(() => {
        clearTimeout(_id)
        let ret = null;
        if (typeof retJson === 'function') {
          retJson()
        } else {
          ret = retJson
        }
        resolve(ret)
      }, this.timeout)
    })
  }
}

export default Mock.getInstance()
